
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"78","height":"72","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.454 28.063c6.192 0 11.212-6.058 11.212-13.531C50.666 7.057 45.646 1 39.454 1S28.242 7.058 28.242 14.531c0 7.474 5.02 13.532 11.212 13.532zM6.158 66.26v3.325c0 .781 2.134 1.415 4.731 1.415h57.13c2.597 0 4.73-.634 4.73-1.415V66.26M32.884 30.442S31.34 34.42 25.93 34.42M46.033 30.442s1.544 3.978 6.954 3.978M5.989 62.273c2.347 0 4.249-3.385 4.249-7.56 0-4.176-1.902-7.56-4.25-7.56-2.346 0-4.248 3.384-4.248 7.56 0 4.175 1.902 7.56 4.249 7.56zM72.49 62.273c2.348 0 4.25-3.385 4.25-7.56 0-4.176-1.902-7.56-4.25-7.56-2.346 0-4.248 3.384-4.248 7.56 0 4.175 1.902 7.56 4.249 7.56zM39.177 39.197v27.458M41.257 45.554s6.186 2.756 11.132-3.537M41.257 51.874c2.417.752 4.986.817 7.435.19a13.908 13.908 0 006.482-3.754M41.257 58.203s8.757 2.82 15.773-3.518M37.231 45.554s-6.186 2.756-11.13-3.537M37.231 51.874a13.625 13.625 0 01-7.435.19 13.908 13.908 0 01-6.48-3.754M37.231 58.203s-8.765 2.82-15.773-3.518M6.257 42.339V38.14c0-2.05 2.124-3.675 4.73-3.675H68.02","stroke":"#333","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M72.705 42.339V38.14c0-2.05-2.124-3.675-4.73-3.675H10.897","stroke":"#333","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round"}})])
          )
        }
      }
    